import { ColumnDef } from '@shared/model'
import { $models } from './$models'
import { deepMerge } from './deepMerge'
import Vue from 'vue'

// ★確認
export interface AxE2ConfigModelDef<DataType> {
  columns: { [colName: string]: ColumnDef }
  // /**
  //  * Overrides, find系の挙動を書き換えをする
  //  */
  // overrides: {
  //   findAll: Function
  //   findAllBy: Function
  //   findById: Function
  //   findAllByIds: Function
  // }
  onSubmitFunction?: (data) => Promise<DataType>
  onDeleteFunction?: (data) => Promise<DataType>
}

const envByHost = {
  'localhost': 'development',
  'houw.cms.cloudec.jp': 'staging',
  'dsdgffyi0h24k.cloudfront.net': 'production',
  // 'd13rikz4eagi31.cloudfront.net': 'staging',
  // 'd1ghzdwij1ab66.cloudfront.net': 'production',
  'house-direct.jp': 'production',
  // 'www.house-direct.jp': 'production',
  // 'lp.house-direct.jp': 'production',
  // 'l.house-direct.jp': 'production'
}

let envStr = null

const env = () => {
  if (envStr) {
    return envStr
  }
  envStr = envByHost[window.location.host]
  if (envStr) {
    return envStr
  }
  if (window.location.host.indexOf('stg') >= 0 || window.location.host.indexOf('staging') >= 0) {
    envStr = 'staging'
    return envStr
  } else if (window.location.host.indexOf('house-direct.jp') >= 0) {
    envStr = 'production'
    return envStr
  } else {
    // Fallback
    envStr = 'development'
    return envStr
  }
}
/**
 * API URL
 * サイトの接続先設定(envの値は使わず、サイトのドメインで切り替える)
 */
const envParams = {
  development: {
    axe2ApiBaseUrl: 'http://localhost:3001/development',
    axe2SiteId: 1,
    payments: {
      gmoPaymentJs: 'https://stg.static.mul-pay.jp/ext/js/token.js',
      gmoPgShopId: 'tshop00057081',
    },
    //axe2DeployedBaseUrl: 'http://localhost:8080/',
    teikiCustomerDiscountRate: 0.04,
    zipSearchUrl: 'https://1bguxwrywh.execute-api.ap-northeast-1.amazonaws.com/staging/searchAddressByZipCode',
    socialPlus: {
      yahoo: {
        login_url: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        registration_url: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        oncart: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        mypage: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
      },
      line: {
        login_url: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/line/authenticate?callback=CALLBACK_URL&extended_items=address,birthdate,email,gender,phone,real_name',
        registration_url: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/line/authenticate?callback=CALLBACK_URL&extended_items=address,birthdate,email,gender,phone,real_name',
        oncart: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/line/authenticate?callback=CALLBACK_URL&extended_items=address,birthdate,email,gender,phone,real_name',
        mypage: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/line/authenticate?callback=CALLBACK_URL&registration=true&trcode=line-login&extended_items=email,real_name,gender,birthdate,address',
      },
      facebook: {
        login_url: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
        registration_url: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
        oncart: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
        mypage: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
      }
    }
  },
  staging: {
    axe2ApiBaseUrl: 'https://1bguxwrywh.execute-api.ap-northeast-1.amazonaws.com/staging',
    axe2SiteId: 1,
    payments: {
      gmoPaymentJs: 'https://stg.static.mul-pay.jp/ext/js/token.js',
      gmoPgShopId: 'tshop00057081',
    },
    //axe2DeployedBaseUrl: 'https://houw.cms.cloudec.jp/wp-content/themes/hwf-staticec/js/AxE2',
    teikiCustomerDiscountRate: 0.04,
    zipSearchUrl: 'https://1bguxwrywh.execute-api.ap-northeast-1.amazonaws.com/staging/searchAddressByZipCode',
    socialPlus: {
      yahoo: {
        login_url: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        registration_url: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        oncart: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        mypage: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        //login_url: 'https://7b21e65407.auth.socialplus.jp/house-direct/house-direct-renewal-test/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        //registration_url: 'https://7b21e65407.auth.socialplus.jp/house-direct/house-direct-renewal-test/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        //oncart: 'https://7b21e65407.auth.socialplus.jp/house-direct/house-direct-renewal-test/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        //mypage: 'https://7b21e65407.auth.socialplus.jp/house-direct/house-direct-renewal-test/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
      },
      line: {
        login_url: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/line/authenticate?callback=CALLBACK_URL&registration=true&extended_items=birthdate,email,real_name,gender,address,phone',
        registration_url: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/line/authenticate?callback=CALLBACK_URL&registration=true&extended_items=birthdate,email,real_name,gender,address,phone',
        oncart: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/line/authenticate?callback=CALLBACK_URL&registration=true&extended_items=birthdate,email,real_name,gender,address,phone',
        mypage: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/line/authenticate?callback=CALLBACK_URL&registration=true&trcode=line-login&extended_items=birthdate,email,real_name,gender,address,phone',
        //login_url: 'https://7b21e65407.auth.socialplus.jp/house-direct/house-direct-renewal-test/line/authenticate?callback=CALLBACK_URL&registration=true&extended_items=birthdate,email,real_name,gender,address,phone',
        //registration_url: 'https://7b21e65407.auth.socialplus.jp/house-direct/house-direct-renewal-test/line/authenticate?callback=CALLBACK_URL&registration=true&extended_items=birthdate,email,real_name,gender,address,phone',
        //oncart: 'https://7b21e65407.auth.socialplus.jp/house-direct/house-direct-renewal-test/line/authenticate?callback=CALLBACK_URL&registration=true&extended_items=birthdate,email,real_name,gender,address,phone',
        //mypage: 'https://7b21e65407.auth.socialplus.jp/house-direct/house-direct-renewal-test/line/authenticate?callback=CALLBACK_URL&registration=true&trcode=line-login&extended_items=birthdate,email,real_name,gender,address,phone',
      },
      facebook: {
        login_url: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
        registration_url: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
        oncart: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
        mypage: 'https://4e677047b7.auth.socialplus.jp/house-direct/house-direct/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
      }
    }
  },
  production: {
    axe2ApiBaseUrl: 'https://28rker8nwe.execute-api.ap-northeast-1.amazonaws.com/production',
    axe2SiteId: 1,
    payments: {
      gmoPaymentJs: 'https://static.mul-pay.jp/ext/js/token.js',
      gmoPgShopId: '9200006717013',
    },
    //axe2DeployedBaseUrl: 'https://dsdgffyi0h24k.cloudfront.net/wp-content/themes/hwf-staticec/js/AxE2',
    teikiCustomerDiscountRate: 0.04,
    zipSearchUrl: 'https://28rker8nwe.execute-api.ap-northeast-1.amazonaws.com/production/searchAddressByZipCode',
    socialPlus: {
      yahoo: {
        login_url: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        registration_url: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        oncart: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
        mypage: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/yahoo/authenticate?callback=CALLBACK_URL&registration=true&trcode=yahoo-login&extended_items=email',
      },
      line: {
        login_url: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/line/authenticate?callback=CALLBACK_URL&extended_items=address,birthdate,email,gender,phone,real_name',
        registration_url: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/line/authenticate?callback=CALLBACK_URL&extended_items=address,birthdate,email,gender,phone,real_name',
        oncart: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/line/authenticate?callback=CALLBACK_URL&extended_items=address,birthdate,email,gender,phone,real_name',
        mypage: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/line/authenticate?callback=CALLBACK_URL&registration=true&trcode=line-login&extended_items=email,real_name,gender,birthdate,address',
      },
      facebook: {
        login_url: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
        registration_url: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
        oncart: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
        mypage: 'https://f3311cc807.auth.socialplus.jp/house-direct/house-direct-renewal-prod/facebook/authenticate?callback=CALLBACK_URL&registration=true&trcode=facebook-login&extended_items=email',
      }
    }
  },
}

/**
 * Config object
 * TODO: load from env
 */
const config = {
  api: {
    baseUrl: envParams[env()].axe2ApiBaseUrl || 'http://localhost:3000/development',
    //baseUrl: process.env.AXE2_API_BASE_URL || 'http://localhost:3000/development',
    axApiProxyPath: '/axApiProxyRequest',
    // TODO sns_typeをcallbackにいれる。https://docs.socialplus.jp/social-login/callback-url
    socialPlus: envParams[env()].socialPlus,
  },
  ax: {
    //site_id: Number(process.env.AXE2_AX_SITE_ID) || 1,
    site_id: Number(envParams[env()].siteId) || 1,
  },
}

/**
 * AxE2用の設定を保持するClass
 */
export class AxE2Config {
  /**
   * API接続先の情報を保持
   */
  api: {
    baseUrl: string
    axApiProxyPath: string
    socialPlus: object
  }
  /**
   * Ax疎通時の設定を保持
   */
  ax: {
    site_id: number
    site_name: string
    // TODO: code で設定するか、idで設定するか、etcetc
    // card_payment_profile_id: number,
  }
  featureConfig: {
    useCodeCoupon: boolean
    useBirthdayIntoPasswordReminder: boolean
  }
  /**
   * フォーム関連のフィールド定義を保持, 主にmodelFormで利用する
   */
  $models: typeof $models
  /**
   * JSON出力されたItemsをハンドリングするための設定
   */
  jsonItems: {
    /**
     * allItemsのJSONを含むHTMLPathを登録 default `/allItems/`
     */
    allItemHtmlPath: string
  }

  constructor() {
    this.api = config.api
    this.ax = {
      site_id: config.ax.site_id,
      // @ts-ignore
      site_name: window.AxEConfigSiteName || 'template',
      // TODO
      // card_payment_profile_id:
    }
    this.featureConfig = {
      useCodeCoupon: true,
      useBirthdayIntoPasswordReminder: false,
    }
    this.jsonItems = {
      allItemHtmlPath: '/allItems/',
    }
    this.$models = $models
    window.addEventListener('$AxE2.scriptLoaded', () => {
      this.mergeConfigWithLoadedWindowObject()
    })
  }

  mergeConfigWithLoadedWindowObject() {
    // @ts-ignore
    const featureConfig = Object.assign({}, this.featureConfig, window.AxEFeatureConfig || {})
    Vue.set(this, 'featureConfig', featureConfig)
  }

  /**
   * フォーム関連のフィールド定義を追加
   * @param modelName - モデル名, 'signup' など
   * @param colName - フィールド名, 'email' など
   * @param colDef - フィールド定義
   */
  addColumn(modelName: string, colName: string, colDef: ColumnDef) {
    this.$models[modelName].columns[colName] = colDef
  }

  /**
   * フォーム関連のフィールド定義の属性を更新
   * @param modelName - モデル名, 'signup' など
   * @param colName - フィールド名, 'email' など
   * @param colDefPartial - フィールド定義
   */
  modifyColumn(modelName: string, colName: string, colDefPartial: Partial<ColumnDef>) {
    this.$models[modelName].columns[colName] = deepMerge(this.$models[modelName].columns[colName], colDefPartial)
  }

  /**
   * フィールド定義を削除
   * @param modelName - モデル名, 'signup' など
   * @param colName - フィールド名, 'email' など
   */
  removeColumn(modelName: string, colName: string) {
    delete this.$models[modelName].columns[colName]
  }

  /**
   * フィールド定義を
   * @param modelName
   * @param colOrders
   */
  sortColumns(modelName: string, colOrders: string[]) {
    if (this.$models[modelName]?.columns) {
      const afterColumns = {}
      const colNames = Object.keys(this.$models[modelName].columns)
      colOrders.map((colName) => {
        if (this.$models[modelName].columns[colName]) {
          afterColumns[colName] = this.$models[modelName].columns[colName]
        }
      })
      colNames
        .filter((colName) => colOrders.indexOf(colName) === -1)
        .map((colName) => {
          afterColumns[colName] = this.$models[modelName].columns[colName]
        })
      this.$models[modelName].columns = afterColumns
    }
  }

  getAxE2DeployedBaseUrl() {
    return envParams[env()].axe2DeployedBaseUrl
  }

  getZipSearchUrl() {
    return envParams[env()].zipSearchUrl
  }

  getSiteId() {
    return envParams[env()].siteId
  }

  getGmoPaymentJs() {
    return envParams[env()].payments.gmoPaymentJs
  }

  getGmoPgShopId() {
    return envParams[env()].payments.gmoPgShopId
  }


  /** お問い合わせ時の管理側メールアドレス */
  inquiry_admin_mail: null
  /** hCaptcha site key */
  captcha_site_key: null
  /** 会員登録バナー */
  sign_up_bunner_img: null
  sign_up_bunner_start: null
  sign_up_bunner_end: null
  /** キャンペーン */
  campaign_on: null
  campaign_url: null
  campaign_btn_id: null
  campaign_start: null
  campaign_end: null
  campaign_applied: null
}

/**
 * Singletonの$AxE2Config
 * "window.$AxE2Config" でアクセス可能。もしくは, Vueコンポーネント内では this.$AxE2Config でアクセス可能。
 * AxE2の初期化後に設定を変更することで、フォームフィールドや接続先の設定の変更が可能
 * - 例) サインアップ時にフィールドを付与: `window.$AxE2Config.addColumn('signup', 'foo', {type: 'STRING', label: 'フー'})`
 * - 例) 利用しないフィールドを削除: `window.$AxE2Config.removeColumn('signup', 'company')`
 */
export const $AxE2Config = new AxE2Config()
// @ts-ignore
window.$AxE2Config = $AxE2Config
